module.exports = __webpack_public_path__ + "static/media/Rob_Gronkowski.b5e7f5bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Rob_Gronkowski.jpg
// module id = 413
// module chunks = 0